import { Header } from './modal.styles';

export default Header;
